// @ts-nocheck
let drctCheckout   = {};
let _funMsgChannel = null;

export const drctJsFunctions = {
    initBroadcastChannel: function(channelName) {
        _funMsgChannel = new BroadcastChannel(channelName);
    },
    initCheckout: function(env) {
        drctCheckout = new monerisCheckout();
        drctCheckout.setMode(env);
		drctCheckout.setCheckoutDiv("divMonerisCheckout");
		drctCheckout.setCallback("page_loaded", this.onMonerisPageLoad);
		drctCheckout.setCallback("cancel_transaction", this.onTransactionCancel);
		drctCheckout.setCallback("error_event", this.onTransactionError);
		drctCheckout.setCallback("payment_submitted", this.onPaymentSubmit);
		drctCheckout.setCallback("payment_receipt", this.onPaymentReceipt);
		drctCheckout.setCallback("payment_complete", this.onPaymentComplete);
        publishMessage({
            type: "PAYMENTS",
            subType: "INIT_CHECKOUT",
            success: true, 
            message: "Checkout Initialized Successfully!" 
        });
	},
    startCheckout: function(ticketNumber) {
		drctCheckout.startCheckout(ticketNumber);
	},
	closeCheckout: function() {
		drctCheckout.closeCheckout();
	},
    onMonerisPageLoad: function(response) {
        publishMessage({
            type: "PAYMENTS",
            subType: "PAGE_LOADED",
            success: true, 
            message: response
        });
	},
    onTransactionCancel: function(response) {
		publishMessage({
            type: "PAYMENTS",
            subType: "TRANSACTION_CANCEL",
            success: true, 
            message: response 
        });
	},
    onTransactionError: function(response) {
		publishMessage({
            type: "PAYMENTS",
            subType: "TRANSACTION_ERROR",
            success: true, 
            message: response 
        });
	},
    onPaymentSubmit: function(response) {
        publishMessage({
            type: "PAYMENTS",
            subType: "PAYMENT_SUBMIT",
            success: true, 
            message: response 
        });
	},
    onPaymentReceipt: function(response) {
        publishMessage({
            type: "PAYMENTS",
            subType: "PAYMENT_RECEIPT",
            success: true, 
            message: response 
        });
	},
    onPaymentComplete: function(response) {
        publishMessage({
            type: "PAYMENTS",
            subType: "PAYMENT_COMPLETE",
            success: true, 
            message: response 
        });
	},
    getRecaptchaToken: function(key) {
        grecaptcha.enterprise.ready(async () => {
            grecaptcha.enterprise.execute(key, {action: 'submit'})
                      .then(function(token) {
                          publishMessage({
                            type: "CAPTCHA",
                            subType: "CAPTCHA_TOKEN",
                            success: true, 
                            message: token 
                          });
                      });
        });
    }
}

function publishMessage(message) {
    _funMsgChannel.postMessage(message);
}